import { Action } from "redux";

export type AddNotification = "ADD_NOTIFICATION";
export const ADD_NOTIFICATION: AddNotification = "ADD_NOTIFICATION";

export interface AddNotificationAction extends Action {
    type: AddNotification;
    payload: {
        isError?: boolean;
        message: string;
    };
}

/**
 * Converts a message to a notification that appears in the app notifications.
 * @param message
 * @param isError
 * @returns
 */
export function addNotification(message: string, isError?: boolean): AddNotificationAction {
    return {
        payload: {
            isError: isError,
            message: message
        },
        type: ADD_NOTIFICATION
    };
}

export type Loading = "LOADING";
export const LOADING: Loading = "LOADING";

export interface LoadingAction {
    type: Loading;
    payload: {
        isLoading: boolean;
        action: string;
    };
}

export type LayoutActions = LoadingAction | AddNotificationAction;
